module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-1.3b5661be.svg";